<ng-container>
    <div class="row" *ngIf="linhas1.length > 0 && linhas1.length > 0">
        <div class="col-sm-6">
            <div class="diff-content">
                <ng-container *ngFor="let linha of linhas1">
                    <div [class]="linha.alterada ? 'linha linha-com-remocao' : 'linha'">
                        <ng-container *ngFor="let texto of linha.textos">
                            <span [class.removido]="texto.removido">{{texto.texto}}</span>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="diff-content">
                <ng-container *ngFor="let linha of linhas2">
                    <div [class]="linha.alterada ? 'linha linha-com-inclusao' : 'linha'">
                        <ng-container *ngFor="let texto of linha.textos">
                            <span [class.adicionado]="texto.adicionado">{{texto.texto}}</span>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>